import {Component, OnInit, ViewChild} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {DialogService} from '../../../services/utils/dialog.service';
import {CompaniesService} from '../../../services/modules/companies.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SnackBarService} from '../../../services/utils/snackBar.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {CommonMetodService} from '../../../services/utils/commonMetod.service';

export enum MediaType {
  Unavailable = 5,
  ExternalDoc = 3,
  S3Media = 1,
  Other = 2
}

@Component({
  selector: 'app-card-training-configuration-form',
  templateUrl: './card-training-configuration-form.component.html',
  styleUrls: ['./card-training-configuration-form.component.scss']
})

export class CardTrainingConfigurationFormComponent implements OnInit {
  s3Bucket: string;
  dataTraining: any;
  idTraining: number;
  formPhoto: FormGroup;
  companyInfoId: string;
  searchValue = '';
  imgCropperResult: string;
  formTrainingType: FormGroup;
  byDateRestriction = false;
  production: boolean = environment.production;

  currentState = 0;
  trainingListLength = 0;
  readonly maxStorageMb = 350;

  files: File[] = [];
  requirementToSelect = [];

  formData: FormData = new FormData();
  controlSearchRequirementSelect = new FormControl();
  columnsTraining: string[] = ['Number', 'ContextQuestion', 'Question', 'CorrectAnswerImage', 'CorrectAnswerText', 'ImageIncorrectAnswer',
  'IncorrectAnswerText', 'Order', 'Actions'];

  @ViewChild(MatSort) sortPersonal: MatSort;
  @ViewChild('paginatorTraining', {read: MatPaginator}) paginatorTraining: MatPaginator;

  tableDataSourceTrainings: MatTableDataSource<any>;
  tableDataSourceTrainingsMultipleFilter: MatTableDataSource<any>;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private ar: ActivatedRoute,
    private dialogService: DialogService,
    private snackBService: SnackBarService,
    private companiesServices: CompaniesService,
    public commonMetodService: CommonMetodService,
  ) { }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    this.ar.params.subscribe((parametros) => {
      this.idTraining = +parametros.Id;
    });
    this.formTrainingType = this.fb.group({
      QuestionOrderType: [0],
      ApprovalPercentage:  [100, [Validators.min(0), Validators.max(100)]],
      RequirementId: [''],
      ValidityType: [0],
      ValidityMonths: [null , [Validators.min(1), Validators.max(1200)]],
      ValidityEndDate: [''],
      ValidityUnlimited: [''],
      State: [0],
      TrainingList: this.fb.array([]),
    });
    this.formPhoto = this.fb.group({
      Photo: new FormControl(''),
    });

    const mesesCtrl  = this.formTrainingType.get('ValidityMonths');
    const finCtrl    = this.formTrainingType.get('ValidityEndDate');
    const unlimitedCtrl = this.formTrainingType.get('ValidityUnlimited');
    const tipoCtrl   = this.formTrainingType.get('ValidityType');

    if (!mesesCtrl || !finCtrl || !unlimitedCtrl || !tipoCtrl) {
      return;
    }

    tipoCtrl.valueChanges.subscribe((t: number) => {
      if (t === 0) {
        mesesCtrl.enable({ emitEvent: false });
        finCtrl.disable({ emitEvent: false });
        unlimitedCtrl.disable({ emitEvent: false });
        finCtrl.setValue(null);
      } else if (t === 1) {
        mesesCtrl.disable({ emitEvent: false });
        finCtrl.enable({ emitEvent: false });
        unlimitedCtrl.disable({ emitEvent: false });
        mesesCtrl.setValue(null);
      } else if (t === 2) {
        mesesCtrl.disable({ emitEvent: false });
        finCtrl.disable({ emitEvent: false });
        unlimitedCtrl.disable({ emitEvent: false });
        mesesCtrl.setValue(null);
        finCtrl.setValue(null);
      }
    });

    const init = tipoCtrl.value as number;
    if (init === 0) {
      mesesCtrl.enable({ emitEvent: false });
      finCtrl.disable({ emitEvent: false });
      unlimitedCtrl.disable({ emitEvent: false });
    } else if (init === 1) {
      mesesCtrl.disable({ emitEvent: false });
      finCtrl.enable({ emitEvent: false });
      unlimitedCtrl.disable({ emitEvent: false });
    } else if (init === 2) {
      mesesCtrl.disable({ emitEvent: false });
      finCtrl.disable({ emitEvent: false });
      unlimitedCtrl.disable({ emitEvent: false });
    }
    this.getTrainingsById();
    this.loadQuestions();
  }

  preventInvalidInput(event: KeyboardEvent): void {
    const invalidChars = ['-', '+', 'e', '.', ','];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  cleanInvalidValue(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/\D/g, '');

    if (value.length > 4) {
      value = value.slice(0, 4);
    }

    let numericValue = Number(value);
    if (numericValue > 1200) {
      numericValue = 1200;
    }

    input.value = numericValue > 0 ? String(numericValue) : '';
    this.formTrainingType.get('ValidityMonths')?.setValue(numericValue > 0 ? numericValue : null);
  }

  getTrainingsById(){
    this.companiesServices.getRequirementTrainingId().subscribe((rest: any[]) => {
      this.requirementToSelect = rest.filter(x => x.IsActive === true)
        .sort((a, b) => { const aVal = a.OrderNum !== null ? a.OrderNum : Infinity;
                          const bVal = b.OrderNum !== null ? b.OrderNum : Infinity;
                          return aVal > bVal ? 1 : -1; });

      this.companiesServices.getTrainingById(this.idTraining).subscribe((rest: any[]) => {
        this.dataTraining = rest;
        this.companyInfoId = this.dataTraining.AdminInfoId;
        let validityTypeValue = 1;

        if (this.dataTraining.ValidityType === 2) {
          validityTypeValue = 2;
        } else if (this.dataTraining.ValidityType === 0 || (this.dataTraining.ValidityMonths && this.dataTraining.ValidityMonths > 0)) {
          validityTypeValue = 0;
        } else if (this.dataTraining.ValidityType === 1 || (this.dataTraining.ValidityEndDate &&
          this.dataTraining.ValidityEndDate !== '')) {
          validityTypeValue = 1;
        }

        this.formTrainingType.patchValue({
          QuestionOrderType: this.dataTraining.QuestionOrderType,
          ApprovalPercentage: (this.dataTraining.ApprovalPercentage ?? 0) === 0 ? 100 : this.dataTraining.ApprovalPercentage,
          RequirementId: this.dataTraining.RequirementId ?? null,
          ValidityType: validityTypeValue,
          ValidityMonths: this.dataTraining.ValidityMonths > 0 ? this.dataTraining.ValidityMonths : null,
          ValidityEndDate: this.dataTraining.ValidityEndDate ?? '',
          ValidityUnlimited: this.dataTraining.ValidityUnlimited ?? '',
          State: this.dataTraining.State ?? 0,
        });
        this.controlSearchRequirementSelect.setValue(this.requirementToSelect.find(x => x.Id === this.dataTraining.RequirementId) ?? null);
        const selectedRequirement = this.requirementToSelect.find(x => x.Id === this.dataTraining.RequirementId);
        this.byDateRestriction = !!selectedRequirement?.ByDate;
        const validityTypeControl = this.formTrainingType.get('ValidityType');
        if (this.byDateRestriction && validityTypeControl?.value === 2) {
          validityTypeControl.setValue(0);
        }
        validityTypeControl?.updateValueAndValidity({ emitEvent: true });

        this.currentState = this.dataTraining.State;
        if (this.dataTraining.State !== 0) {
          this.formTrainingType.disable({ emitEvent: false });
        }
      });
    });
  }

  loadQuestions() {
    this.companiesServices.getTrainingIdQuestion(this.idTraining).subscribe((rest: any[]) => {
      const orderedQuestions = rest.sort((a, b) => a.Order - b.Order);
      this.trainingListLength = orderedQuestions.length;
      this.formTrainingType.setControl('TrainingList', this.fb.array(orderedQuestions.map(x => {
        return this.fb.group({
          Number: [x.Order],
          IdQuestion: [x.Id],
          Question: [x.Text, Validators.required],
          ContextQuestion: [x.ContextMediaPath, Validators.required],
          ContextMediaType: [x.ContextMediaType],
          Order: [x.Order, Validators.required],
          CorrectAnswerImage: [x.Answers.find(a => a.IsCorrect === true)?.ImagePath ?? ''],
          CorrectAnswerText: [x.Answers.find(a => a.IsCorrect === true)?.Text],
          ImageIncorrectAnswer: [x.Answers.find(a => a.IsCorrect === false)?.ImagePath ?? ''],
          IncorrectAnswerText: [x.Answers.find(a => a.IsCorrect === false)?.Text],
          CorrectAnswerId: [x.Answers.find(a => a.IsCorrect === true)?.Id],
          IncorrectAnswerId: [x.Answers.find(a => a.IsCorrect === false)?.Id],
          Actions: [''],
        });
      })));
      this.tableDataSourceTrainings = new MatTableDataSource((this.formTrainingType.get('TrainingList') as FormArray).controls);
      this.tableDataSourceTrainingsMultipleFilter = new MatTableDataSource((
        this.formTrainingType.get('TrainingList') as FormArray).controls);
      this.configTableTrainings();
    });
  }

  configTableTrainings() {
    this.tableDataSourceTrainings.filterPredicate = (data: FormGroup, filter: string) => {
      return Object.values(data.controls).some(x => RegExp(filter).test(JSON.stringify(x.value).trim().toUpperCase()));
    };
    this.tableDataSourceTrainings.paginator = this.paginatorTraining;
    this.tableDataSourceTrainings.sort = this.sortPersonal;
  }

  searchFilterPagination(value: string) {
    this.searchValue = value.trim().toLowerCase();

    this.tableDataSourceTrainings.filter = this.searchValue;

    // Reiniciar a la primera página
    if (this.tableDataSourceTrainings.paginator) {
      this.tableDataSourceTrainings.paginator.firstPage();
    }
  }

  changeRequirementSelect(event: any) {
      this.controlSearchRequirementSelect.setValue(event);

      const requirementControl = this.formTrainingType.get('RequirementId');
      if (requirementControl) {
        requirementControl.setValue(event?.Id ?? null);
      }

      this.byDateRestriction = !!event?.ByDate;

      const validityTypeControl = this.formTrainingType.get('ValidityType');
      if (this.byDateRestriction && validityTypeControl?.value === 2) {
        validityTypeControl.setValue(0);
      }
      validityTypeControl?.updateValueAndValidity({ emitEvent: true });
  }

  onCreateQuestion(): void {
    this.dialogService.openDialogTrainingConfigurationForm('PREGUNTA Y RESPUESTA', false ,
      true, this.idTraining).afterClosed().subscribe(x => {});
  }

  onClose() {
    this.router.navigate(['/admin/companies/companyId']);
  }

  getMediaIcon(mediaType: number): string | null {
    switch (mediaType) {
      case 0: return 'videocam';
      case 1: return 'insert_drive_file';
      case 2: return 'volume_up';
      case 3: return 'link';
      case 4: return 'image';
      case 5: return null;
      default: return null;
    }
  }

  onSave(): void {
      const form = this.formTrainingType;
      const validityTypeValue = form.get('ValidityType')?.value;
      const validityMonthsCtrl = form.get('ValidityMonths');
      const validityEndDateCtrl = form.get('ValidityEndDate');
      const validityMonthsValue = validityMonthsCtrl?.value;
      const validityEndDateValue = validityEndDateCtrl?.value;

      if (validityTypeValue === 0) {
      if (validityMonthsCtrl?.disabled || validityMonthsValue === null || validityMonthsValue === '' || +validityMonthsValue < 1) {
        this.snackBService.openWarning('Debes elegir la cantidad de meses.', '', 4000);
        return;
      }
    }
      if (validityTypeValue === 1) {
      if (validityEndDateCtrl?.disabled || !validityEndDateValue || validityEndDateValue.toString().trim() === '') {
        this.snackBService.openWarning('Debes elegir una fecha.', '', 4000);
        return;
      }
    }
      const model = {
      AdminInfoId: this.companyInfoId,
      Name: this.dataTraining.Name ?? '',
      Description: this.dataTraining.Description ?? '',
      State: this.dataTraining.State ?? 0,
      QuestionOrderType: form.get('QuestionOrderType')?.value === 0 ? 'Random' : 'Sequential',
      ApprovalPercentage: form.get('ApprovalPercentage')?.value ?? 100,
      RequirementId: form.get('RequirementId')?.value ?? null,
      ValidityType: validityTypeValue,
      ValidityMonths: validityTypeValue === 0 ? +validityMonthsValue : 0,
      ValidityEndDate: validityTypeValue === 1 ? validityEndDateValue : '',
      ValidityUnlimited: validityTypeValue === 2 ? form.get('ValidityUnlimited')?.value : '',
      Order: this.dataTraining.Order ?? 0,
      StateTranslation: this.dataTraining.StateTranslation ?? '',
      ImagePath: this.dataTraining.ImagePath ?? '',
    };

      this.companiesServices.putTraining(model, this.idTraining).subscribe(
      () => {
        this.snackBService.openSuccess('¡Guardado con éxito!', '', 5000);
      },
      err => {
        this.snackBService.openWarning('Error guardando datos', '', 5000);
      }
    );
  }

  openImgVideo(doc: string, mediaType: MediaType): void {
    if (mediaType === MediaType.Unavailable) {
      this.snackBService.openWarning('No disponible', '', 3000);
      return;
    }

    const url = mediaType === MediaType.ExternalDoc
      ? doc
      : `${this.s3Bucket}${doc}`;

    window.open(url, '_blank');
  }

  getImg(logo) {
    return (logo === null ? 'assets/images/sin_imagen.png' : logo);
  }

  editQuestion(questionObj): void {
    this.dialogService.openDialogTrainingConfigurationForm('EDITAR PREGUNTA', true, true, this.idTraining, questionObj.value)
      .afterClosed().subscribe(reload => {if (reload) { this.loadQuestions(); }
      });
  }

  deleteQuestion(questionId): void {
    this.dialogService.openDialogConfirm('¿Estás seguro de eliminar esta pregunta?', true, true, 'Cancelar')
      .afterClosed().subscribe((result) => {
        if (result) {
          this.companiesServices.deleteTrainingQuestion(questionId).subscribe(() => {
            this.snackBService.openSuccess('Pregunta eliminada correctamente', '', 5000);
            this.loadQuestions();
          }, error => {
            this.snackBService.openWarning('Error al eliminar la pregunta', '', 5000);
          });
        }
      });
  }

}
